import { mods } from '@approvalmax/theme';
import { Button } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { font } from 'modules/styles';
import styled, { css } from 'styled-components';

import SignUpProgress from '../SignUpProgress/SignUpProgress';

export const Root = styled.div`
    background-color: #fff;
    padding: 40px 50px 50px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

export const ProgressContainer = styled(SignUpProgress)`
    margin-bottom: 20px;
`;

export const ProgressLine = styled.div<StyledMods<{ width: number; fill?: boolean }>>`
    height: 5px;
    border-radius: 4px;
    background-color: #cfe1d3;

    ${mods('fill', true)`
        background-color: #4c8a5c;
    `};

    ${({ $width }) => css`
        width: ${$width}px;
    `}

    & + & {
        margin-left: 5px;
    }
`;

export const BigText = styled.div`
    ${font(20, '#000')};
`;

export const EmailText = styled.div`
    ${font(24, '#000', 'bold')};
    margin: 10px 0;
    word-break: break-word;
`;

export const ChangeEmailButton = styled(Button)`
    margin-top: 20px;
    margin-bottom: 50px;
`;

export const OpenEmailContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
`;

export const OpenEmailLink = styled.a`
    width: 127px;
    height: 84px;
    border-radius: 8px;
    background-color: #f3f3f3;
    color: #384650;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    text-decoration: none;
`;

export const FindEmailTitle = styled.div`
    ${font(14, '#000', 'bold')};
    margin-top: 50px;
`;

export const FindEmail = styled.div`
    ${font(14, '#000')};
    margin-bottom: 15px;
`;
